<template>
  <div class="section-footer">
    <span>
      © All rights reserved. <strong>Commercia</strong> {{ new Date().getFullYear() }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'CommerciaVueFooter'
}
</script>
<style scoped>
.section-footer{
  background: transparent !important;
  position: absolute;
  bottom: 5px;
  right: 0;
  left: 240px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
